/**
 * Formats a number for display in a custom amount input field.
 * - Returns empty string for zero or negative values
 * - Shows 2 decimal places when the value has a decimal part
 * - Otherwise shows the integer string
 */
export function formatCustomAmount(amount: number): string {
	if (amount <= 0) return '';
	if (amount.toString().includes('.')) return Number(amount).toFixed(2);
	return amount.toString();
}
